import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { connect } from 'react-redux';

import audioVideoCheckSelector from '../../../../selectors/testOverview/testComponents/audioVideoCheck/AudioVideoCheckSelector';
import TestComponentHardwareAccessCheck from '../hardwareAccessCheck/TestComponentHardwareAccessCheck';
import PreCheckAction from '../preChecks/PreCheckAction';
import ZoomTestCallCheck from '../zoomTestCallCheck/ZoomTestCallCheck';

const AudioVideoCheck = (props) => {
    const {
        hardwareStatusDescription,
        isCompleted,
        isCurrent,
        isFailed,
        isZoomCheckFailed,
        offerHardwareGrantAccess,
        offerHardwareRetryRequestAccess,
        offerHardwareSwitchDevice,
        showHardwareAccessCheck,
        showZoomTestCallCheck,
        title,
        zoomTestCallDetail = {},
    } = props;

    return (
        <PreCheckAction
            current={isCurrent}
            completed={isCompleted}
            failed={isFailed}
            title={title}
        >
            <React.Fragment>
                { showHardwareAccessCheck &&
                    <TestComponentHardwareAccessCheck
                        statusDescription={hardwareStatusDescription}
                        offerGrantAccess={offerHardwareGrantAccess}
                        offerRetryRequestAccess={offerHardwareRetryRequestAccess}
                        offerSwitchDevice={offerHardwareSwitchDevice}
                    />
                }

                { showZoomTestCallCheck &&
                    <ZoomTestCallCheck
                        isFailed={isZoomCheckFailed}
                        credentials={zoomTestCallDetail}
                    />
                }
            </React.Fragment>
        </PreCheckAction>
    );
};

const mapStateToProps = (state, ownProps) => {
    return audioVideoCheckSelector.mapStateToProps(state, ownProps);
};

AudioVideoCheck.propTypes = {
    hardwareStatusDescription: PropTypes.string,
    isCompleted: PropTypes.bool.isRequired,
    isCurrent: PropTypes.bool.isRequired,
    isFailed: PropTypes.bool.isRequired,
    isZoomCheckFailed: PropTypes.bool.isRequired,
    offerHardwareGrantAccess: PropTypes.bool.isRequired,
    offerHardwareRetryRequestAccess: PropTypes.bool.isRequired,
    offerHardwareSwitchDevice: PropTypes.bool.isRequired,
    showHardwareAccessCheck: PropTypes.bool.isRequired,
    showZoomTestCallCheck: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    zoomTestCallDetail: PropTypes.object,
};

export default memo(connect(mapStateToProps)(AudioVideoCheck));
